const extractNumber = (value) => {
  if (typeof value === 'number') return value
  if (typeof value !== 'string') return null

  const match = value.match(/\d+/)
  return match ? parseInt(match[0], 10) : null
}

export const determineServiceType = (services, serviceName) => {
  if (!services || typeof services !== 'object' || !serviceName) {
    return { type: 'outOfPocket', value: null }
  }

  // Get the service from the object
  const service = services[serviceName]

  // We check for number_of_sessions first as it takes precedence over bank_of_hours
  // We also check that the value is not 'disabled' as the service field will always
  // exist but will be set to 'disabled' if not applicable
  if (!service) {
    return { type: 'outOfPocket', value: null }
  }

  if (service.number_of_sessions && service.number_of_sessions !== 'disabled') {
    const sessions = extractNumber(service.number_of_sessions)
    return { type: 'default', value: sessions }
  }

  if (service.bank_of_hours && service.bank_of_hours !== 'disabled') {
    const hours = extractNumber(service.bank_of_hours)
    return { type: 'bankOfHours', value: hours }
  }

  return { type: 'outOfPocket', value: null }
}
